export default "__VITE_PUBLIC_ASSET__23a8f80c__"